<div class="overlay" [ngClass]="{'overlay-enhanced': overlay, 'dock-top': dock === 'top', 'dock-bottom': dock === 'bottom', 'dock-left': dock === 'left', 'dock-right': dock === 'right'}">
  <div class="modal" [ngClass]="{'small': size === 'small', 'medium': size === 'medium', 'large': size === 'large', 'modal-overlay': overlay, 'docked': dock && dock !== 'center'}">
    <header class="modal-header">
      <span class="title">{{title}}</span>
      <img class="pointer" src="assets/project-icons/close.svg" alt="X" (click)="closeEvent.emit()">
    </header>
    <div class="modal-content">
      <ng-content></ng-content>
    </div>
    <footer class="modal-footer" [ngClass]="{'small': size === 'small', 'medium': size === 'medium', 'large': size === 'large'}">
      @for (btn of footerButtons; track btn) {
        <button (click)="btn.onClick()"
                [ngClass]="btn.type === 'primary' ? 'primary-btn' : (btn.type === 'secondary' ? 'secondary-btn' : 'warning-btn')"
        >
          {{btn.text}}
        </button>
      }
    </footer>
  </div>
</div>
